import { render, staticRenderFns } from "./chat_mobile.vue?vue&type=template&id=c4de270e&scoped=true&"
import script from "./chat_mobile.vue?vue&type=script&lang=js&"
export * from "./chat_mobile.vue?vue&type=script&lang=js&"
import style0 from "./chat_mobile.vue?vue&type=style&index=0&id=c4de270e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4de270e",
  null
  
)

export default component.exports